import React, {useContext} from 'react'
import AuthLayout from "../../templates/auth-templates";
import ImgLoginPanel from "../../assets/images/auth/img-auth-1.jpg"
import Logo from "../../components/Logo/Logo";
import Alert from '../../components/alert/alert'; 
import AuthContext from '../../context/AuthContext' 
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const LoginPage  = () => { 
    let { loginUser, errorMessage } = useContext(AuthContext)  

    const [t, i18n] = useTranslation('common');
    
    return (
      <AuthLayout>   
        <div className="col-md-12"> 
          <div className="card-body">  
            <p class="mb-3 f-w-400 text-center mb-4 mt-2 hedaer-log">ANNMELDEN</p>   
            {errorMessage && <Alert>{errorMessage &&  t('login.error') }</Alert>}
            <form onSubmit={loginUser}>
            <div className="form-group mb-2"> 
              <input 
                type="text" 
                className="form-control" 
                name="username"
                placeholder={t('auth.Username')}
              />
            </div>
            <div className="form-group mb-3"> 
              <input 
                type="password" 
                className="form-control" 
                name="password" 
                placeholder={t('auth.Password')}
              />
            </div> 
             
            <button type="submit" className="btn btn-orange mb-4">{t('auth.SignIn')}</button> 
            <p class="mt-2 mb-4 text-muted">{t('auth.ForgotYourPassword')}? <Link to='/reset-password' class="f-w-400">{t('auth.Reset')}</Link> </p> 
            </form>
            
          </div>
        </div>  
      </AuthLayout>
    )
}

 

export default LoginPage  